export default __webpack_public_path__ + "static/media/415.980f9ccf.jpg";